module.exports = __webpack_public_path__ + "static/img/friend1.8c32632.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/friend1.jpeg
// module id = EVUm
// module chunks = 1